import React from "react";

import StaffProfileUI from "./StaffProfileUI";

export default function ManagerAdminProfileUI(props) {
   return <StaffProfileUI {...props} mode="managerAdmin" />;
}
